var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var ExportTask_1;
import '@symon-ai/wisepipe-common'; // force import for JsonSchema
import { Utils } from '@symon-ai/wisepipe-common';
import { BeforeDeserialized, DateConverter, JSON, JsonConverter, JsonSchema } from '@symon-ai/wisepipe-serialize';
import { OrgPlan } from '@symon-ai/wisepipe-user';
import './exportCompletedWarning'; // force import for JsonSchema
export var ExportTaskStatus;
(function (ExportTaskStatus) {
    ExportTaskStatus["Running"] = "running";
    ExportTaskStatus["Completed"] = "completed";
    ExportTaskStatus["Failed"] = "failed";
    ExportTaskStatus["Cancelled"] = "cancelled";
})(ExportTaskStatus || (ExportTaskStatus = {}));
const ExportTaskSchema = {
    $id: 'urn:wisepipe-common-export:ExportTask',
    type: 'object',
    properties: {
        userID: { type: 'string', format: 'uuid' },
        userName: { type: 'string' },
        userEmail: { type: 'string' },
        orgID: { type: 'string', format: 'uuid' },
        orgPlan: { type: 'string', enum: Object.values(OrgPlan) },
        exportTaskID: { type: 'string', uid: 9 },
        name: { type: 'string', minLength: 1 },
        exportID: { type: 'string', uid: 9 },
        elementID: { type: 'string', uid: 10 },
        parquetS3File: { $ref: 'urn:wisepipe-common:S3File' },
        pipeID: { type: 'string' },
        runName: { type: 'string' },
        randomSampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        sampleLocation: { $ref: 'urn:wisepipe-common:S3File' },
        rowCountS3File: { $ref: 'urn:wisepipe-common:S3File' },
        schemaS3File: { $ref: 'urn:wisepipe-common:S3File' },
        status: { type: 'string', enum: Object.values(ExportTaskStatus) },
        startTime: { type: 'string', format: 'date-time' },
        endTime: { type: 'string', format: 'date-time' },
        warnings: {
            type: 'array',
            items: { $ref: 'urn:wisepipe-common-export:ExportCompletedWarning' }
        },
        transient: { type: 'boolean' },
        error: { type: 'object' }
    },
    // status determines which other properties are required
    if: { properties: { status: { const: ExportTaskStatus.Completed } } },
    then: { required: ['endTime'] },
    else: {
        if: { properties: { status: { const: ExportTaskStatus.Cancelled } } },
        then: { required: ['endTime'] },
        else: {
            if: { properties: { status: { const: ExportTaskStatus.Failed } } },
            then: { required: ['error', 'endTime'] }
        }
    },
    required: ['userID', 'orgID', 'exportTaskID', 'name', 'exportID', 'parquetS3File', 'status', 'startTime', 'warnings']
};
/**
 * Represents an instance of an export job that is being executed.
 * Contains details regarding the actual execution of the export.
 */
// In older version, orgPlan was called userPlan and orgID did not exist
// Where orgID is missing it should be assumed orgID = userID
let ExportTask = ExportTask_1 = class ExportTask {
    setDefaults() {
        this.transient = false;
    }
    constructor(orgID, userID, exportTaskID, name, exportID, elementID, parquetS3File, status, transient, startTime, endTime, warnings, error, orgPlan, userName, userEmail, pipeID, runName, randomSampleLocation, sampleLocation, rowCountS3File, schemaS3File) {
        this.orgID = orgID;
        this.userID = userID;
        this.orgPlan = orgPlan;
        this.exportTaskID = exportTaskID;
        this.name = name;
        this.exportID = exportID;
        this.elementID = elementID;
        this.parquetS3File = parquetS3File;
        this.pipeID = pipeID;
        this.runName = runName;
        this.randomSampleLocation = randomSampleLocation;
        this.sampleLocation = sampleLocation;
        this.rowCountS3File = rowCountS3File;
        this.schemaS3File = schemaS3File;
        this.status = status;
        this.startTime = startTime;
        this.endTime = endTime;
        this.warnings = warnings !== undefined ? warnings : [];
        this.error = error;
        this.transient = transient;
        this.userName = userName;
        this.userEmail = userEmail;
        JSON.validate(this, ExportTask_1);
    }
    static newID() {
        return Utils.newID();
    }
    static bufferID(exportID) {
        return Utils.base64StringToBuffer(exportID);
    }
};
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ExportTask.prototype, "startTime", void 0);
__decorate([
    JsonConverter(new DateConverter('date-time'))
], ExportTask.prototype, "endTime", void 0);
__decorate([
    BeforeDeserialized()
], ExportTask.prototype, "setDefaults", null);
ExportTask = ExportTask_1 = __decorate([
    JsonSchema(ExportTaskSchema)
], ExportTask);
export { ExportTask };
//# sourceMappingURL=exportTask.js.map